import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import apiManager from '@/api/AxiosInstance';
import AlertModal from '@/components/Common/Modal/AlertModal';
import PhoneAuth from '@/components/Common/PhoneAuth';
import ButtonFooter from '@/components/Footer/ButtonFooter';
import MenuHeader from '@/components/Header/MenuHeader';
import { useToastContext } from '@/contexts/Common/ToastContext';
import { useMemberContext } from '@/contexts/Member/MemberContext';
import '@/css/tailwind.css';

const PhoneNumberChange = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isNeedChangePhoneNumber = location.state?.needChangePhoneNumber || false;
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false);
  const [phoneNumberMessage, setPhoneNumberMessage] = useState('');
  const [errorPhoneNumber, setErrorPhoneNumber] = useState(false);
  const { member, updateMember } = useMemberContext();
  const [memberInfo, setMemberInfo] = useState<MemberInfo>({
    name: '',
    phoneNumber: '',
    marketing: true,
    authNumber: '',
    authenticate: false,
  });

  const { showToast } = useToastContext();

  useEffect(() => {
    setMemberInfo((prevMemberInfo) => ({
      ...prevMemberInfo,
      authenticate: true,
    }));
  }, [member]);

  const handleChangeButton = () => {
    apiManager
      .patch('/api/v1/members', memberInfo)
      .then((response) => {
        showToast('휴대폰 번호를 변경했어요.', 'success', 'bottom');
        updateMember(response?.data as Member);
        navigate('/setting');
      })
      .catch((error) => {
        setPhoneNumberMessage('휴대폰 번호 변경에 실패했습니다. 다시 확인해주세요.');
        setErrorPhoneNumber(true);
      });
  };

  useEffect(() => {
    if (!!isNeedChangePhoneNumber) {
      history.pushState(null, '', location.pathname);

      const onPopState = () => {
        setIsOpenAlertModal(true);
        history.pushState(null, '', location.pathname);
      };

      window.addEventListener('popstate', onPopState);
      return () => {
        window.removeEventListener('popstate', onPopState);
      };
    }
  }, []);

  const handleClickPrev = () => {
    navigate(-1);
  };

  return (
    <>
      <MenuHeader title="휴대폰 번호 변경" onClickPrevBtn={handleClickPrev}></MenuHeader>
      <div className="w-full p-4 pt-[60px]">
        <section className="pt-6">
          {!!isNeedChangePhoneNumber && (
            <div className="bg-blue-0 px-4 py-[19px] rounded-[10px] text-grey-8 mb-[30px]">
              <p className="font-bold text-[18px]">휴대폰 번호를 변경해주세요.</p>
              <div className="font-normal text-[14px] mt-4">
                현재 사용 중인 휴대폰 번호가 유효하지 않아요. 원활한 서비스 이용을 위해 휴대폰 번호를 변경해주세요.
              </div>
            </div>
          )}
          <PhoneAuth
            isSign={false}
            prevPhoneNumber={member?.phoneNumber}
            memberInfo={memberInfo}
            updateMemberInfo={setMemberInfo}
          ></PhoneAuth>
        </section>
        <div className="flex items-center justify-center fixed w-full mx-auto my-0 px-4 pb-2 bottom-0 left-0 right-0 max-w-[720px] min-w-[280px] bg-gray-0">
          <ButtonFooter
            title="변경하기"
            isDisabled={!memberInfo.isAuthenticateCode}
            onClick={handleChangeButton}
          ></ButtonFooter>
        </div>
      </div>

      <AlertModal
        isOpen={isOpenAlertModal}
        title="유효하지 않은 휴대폰 번호"
        content={
          <div className="break-keep">
            현재 휴대폰 번호가 유효하지 않아 서비스 이용에 제한이 있어요. 원활한 서비스 이용을 위해 휴대폰 번호를
            변경해주세요.
          </div>
        }
        onClose={() => {
          setIsOpenAlertModal(false);
        }}
      />
    </>
  );
};

export default PhoneNumberChange;
